export default __webpack_public_path__ + "static/media/2005-IMcover.4ece767a.jpg";